import { render, staticRenderFns } from "./RecettePdf.vue?vue&type=template&id=3770087a"
import script from "./RecettePdf.vue?vue&type=script&lang=js"
export * from "./RecettePdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports